// extracted by mini-css-extract-plugin
export default {"Blink":"DotDotDot_Blink__TVUod","blink":"DotDotDot_blink__gaBfO"};